"use client"

import { usePathname } from "next/navigation"

/**
 * Pages that have an AMP version on amp.tokenkickstarter.com.
 * The link tag tells Google about the AMP counterpart.
 */
const AMP_PAGES = new Set([
    "/",
    "/blog",
    "/whitepaper",
    // Docs
    "/docs",
    "/docs/api",
    "/docs/api/rest-api",
    "/docs/api/rate-limits",
    "/docs/api/web3-integration",
    "/docs/api/webhooks",
    "/docs/getting-started",
    "/docs/getting-started/best-practices",
    "/docs/getting-started/platform-overview",
    "/docs/getting-started/quick-start",
    "/docs/getting-started/understanding-presales",
    "/docs/guides",
    "/docs/guides/create-presale",
    "/docs/guides/managing-funds",
    "/docs/guides/marketing-presale",
    "/docs/guides/understanding-tokenomics",
    "/docs/security",
    "/docs/security/anti-rug-features",
    "/docs/security/audit-reports",
    "/docs/security/kyc-process",
    "/docs/security/security-measures",
    "/docs/smart-contracts",
    "/docs/smart-contracts/contract-overview",
    "/docs/smart-contracts/deployed-contracts",
    "/docs/smart-contracts/liquidity-locking",
    "/docs/smart-contracts/security-features",
    "/docs/smart-contracts/token-standards",
    // Static pages
    "/audit",
    "/kyc",
    "/contact",
    "/terms",
    "/privacy",
    "/disclaimer",
])

// Blog article pages also have AMP versions
function hasAmpVersion(path: string): boolean {
    if (AMP_PAGES.has(path)) return true
    if (path.startsWith("/blog/")) return true // /blog/[slug]
    return false
}

function getAmpUrl(path: string): string {
    const base = "https://amp.tokenkickstarter.com"
    if (path === "/") return `${base}/`
    // Middleware handles routing static pages to /amp/pages/* internally
    return `${base}${path}`
}

export function AmpLink() {
    const pathname = usePathname()
    if (!hasAmpVersion(pathname)) return null
    return <link rel="amphtml" href={getAmpUrl(pathname)} />
}
